<template>
  <div v-if="readPermission" class="tenantManagementContainer">
    <div class="configurePageContainer" style="height: 100%; width: 100%">
      <div v-if="isLoading" style="position: absolute; top: 50%; left: 65%; transform: translate(-50%, -50%); display: flex; justify-content: center; align-items: center">
        <div class="spinner-border text-primary spinner-grow-xl" roleCategories="status"></div>
      </div>
      <div v-if="!showAddForm" class="customRowTenant">
        <p class="jobHistoryTitle" style="text-align: left">{{ $t('models.title') }}</p>
        <div class="searchBar">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <circle cx="6.5" cy="7.45996" r="5.75" stroke="#8F969B" stroke-width="1.5" />
            <path d="M11 11.96L15 15.96" stroke="#8F969B" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <input type="text" class="searchInput" :placeholder="$t('models.search_placeholder')" v-model="search" @input="fetchModels" />
        </div>
      </div>

      <!-- Search & Add Button -->
      <div v-if="!showAddForm" class="tableHeadingsNew">
        <div class="tableHeadingsNew" style="margin-top: 20px">
          <div class="customRow">
            <img src="/backward.svg" alt="Back" style="cursor: pointer" @click="goToPreviousPage" />
            <span class="pageOfTitle">{{ $t('models.pagination.page') }} {{ page }} {{ $t('models.pagination.of') }} {{ totalPages }}</span>
            <img src="/forward.svg" alt="Next" style="cursor: pointer" @click="goToNextPage" />
            <div class="pageDiv" @click.stop="togglePageSizeDropdown">
              <span class="pageDivText">{{ pageSize }}</span>
              <img src="/arrowDownNew.png" class="arrowDownNew" alt="" />

              <ul ref="dropdownEl" v-if="showPageSizeDropdown" class="pageSizeDropdownNew" @click.stop>
                <li v-for="size in pageSizeOptions" :key="size" @click.stop="selectPageSize(size)">
                  {{ size }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div style="display: flex; gap: 17px">
          <SecondaryButton v-if="writePermissionMaster || writePermission" @click="handleAddModel">{{ $t('models.add_button') }}</SecondaryButton>
        </div>
      </div>

      <!-- Add/Edit Model Form -->
      <div v-if="showAddForm && (writePermissionMaster || writePermission)" class="createModelBody">
        <div class="createModelHeader">
          <svg @click="cancelAdd" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <path d="M5.25 11.25H20.25C20.45 11.25 20.64 11.33 20.78 11.47C20.92 11.61 21 11.8 21 12C21 12.2 20.92 12.39 20.78 12.53C20.64 12.67 20.45 12.75 20.25 12.75H5.25C5.05 12.75 4.86 12.67 4.72 12.53C4.58 12.39 4.5 12.2 4.5 12C4.5 11.8 4.58 11.61 4.72 11.47C4.86 11.33 5.05 11.25 5.25 11.25Z" fill="black" />
            <path d="M5.56 12L11.78 18.22C11.92 18.36 12 18.55 12 18.75C12 18.95 11.92 19.14 11.78 19.28C11.64 19.42 11.45 19.5 11.25 19.5C11.05 19.5 10.86 19.42 10.72 19.28L3.97 12.53C3.9 12.46 3.84 12.38 3.81 12.29C3.77 12.2 3.75 12.1 3.75 12C3.75 11.9 3.77 11.8 3.81 11.71C3.84 11.62 3.9 11.54 3.97 11.47L10.72 4.72C10.86 4.58 11.05 4.5 11.25 4.5C11.45 4.5 11.64 4.58 11.78 4.72C11.92 4.86 12 5.05 12 5.25C12 5.45 11.92 5.64 11.78 5.78L5.56 12Z" fill="black" />
          </svg>
          <span class="newPageTitle">{{ editMode ? $t('models.forms.edit_title') : $t('models.forms.add_title') }}</span>
        </div>
        <div class="form-grid">
          <div class="form-field">
            <label>{{ $t('models.forms.labels.classification_model_name') }}</label>
            <input
              type="text"
              v-model.trim="newModel.classification_model_name"
              :class="{
                'error-border': showErrors && errors.classification_model_name,
              }"
              :placeholder="$t('models.forms.placeholders.enter_classification_model_name')"
            />
            <span class="error-text" v-if="showErrors && errors.classification_model_name">
              {{ errors.classification_model_name }}
            </span>
          </div>

          <div class="form-field">
            <label>{{ $t('models.forms.labels.extraction_model_name') }}</label>
            <input
              type="text"
              v-model.trim="newModel.extraction_model_name"
              :class="{
                'error-border': showErrors && errors.extraction_model_name,
              }"
              :placeholder="$t('models.forms.placeholders.enter_extraction_model_name')"
            />
            <span class="error-text" v-if="showErrors && errors.extraction_model_name">
              {{ errors.extraction_model_name }}
            </span>
          </div>

          <div class="form-field">
            <label>{{ $t('models.forms.labels.model_endpoint') }}</label>
            <input
              type="text"
              v-model.trim="newModel.extraction_model_endpoint"
              :class="{
                'error-border': showErrors && errors.extraction_model_endpoint,
              }"
              :placeholder="$t('models.forms.placeholders.enter_model_endpoint')"
            />
            <span class="error-text" v-if="showErrors && errors.extraction_model_endpoint">
              {{ errors.extraction_model_endpoint }}
            </span>
          </div>

          <div class="form-field">
            <label>{{ $t('models.forms.labels.status') }}</label>
            <IsActiveComponentV1 v-model="newModel.is_active" @change="handleStatusChange" />
          </div>
        </div>
        <div class="button-group">
          <button class="cancel-btn" @click="cancelAdd">{{ $t('models.buttons.cancel') }}</button>
          <button class="save-btn" @click="saveDepartment">{{ $t('models.buttons.save') }}</button>
        </div>
      </div>

      <!-- models Table -->
      <div v-if="!showAddForm" class="tableContainer" style="margin-top: 20px">
        <table class="customTable">
          <thead class="customTableHeader">
            <tr class="customTableRow">
              <th>{{ $t('models.table.sr_no') }}</th>
              <th>{{ $t('models.table.classification_model_name') }}</th>
              <th>{{ $t('models.table.extraction_model_name') }}</th>
              <th>{{ $t('models.table.model_endpoint') }}</th>
              <th>{{ $t('models.table.is_active') }}</th>
              <th>{{ $t('models.table.action') }}</th>
            </tr>
          </thead>
          <tbody class="customTableBody">
            <tr v-for="(model, index) in models" :key="model.id" style="height: 50px !important">
              <td>{{ index + 1 + (page - 1) * pageSize }}</td>
              <td>{{ model.classification_model_name }}</td>
              <td>{{ model.extraction_model_name }}</td>
              <td class="endpoint-cell">
                <div class="tooltip-container">
                  <span class="endpoint-text">{{ model.extraction_model_endpoint }}</span>
                  <div class="tooltip">
                    {{ model.extraction_model_endpoint }}
                  </div>
                </div>
              </td>
              <td>
                <div class="toggle-wrapper">
                  <CustomToggle v-if="writePermissionMaster || writePermission" :modelValue="model.is_active" @update:modelValue="(value) => handleStatusToggle(model, value)" />
                  <span v-else>{{ model.is_active ? $t('models.status.active') : $t('models.status.inactive') }}</span>
                </div>
              </td>
              <td>
                <CustomHyperlink v-if="writePermissionMaster || writePermission" @click="editModel(model)">{{ $t('models.actions.edit') }}</CustomHyperlink>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ConfirmationModal :show="showConfirmModal" :message="$t('models.modals.confirm_status.message', { modelName: pendingStatusChange?.field?.classification_model_name })" @close="closeConfirmModal" @confirm="confirmStatusChange" />
  </div>
  <div v-else>
    <PermissionAlert />
  </div>
</template>

<script>
import { get, post, put } from '@/utils/api'
import { showToast } from '@/utils/toast'
import CustomToggle from '@/components/CustomToggle/CustomToggle.vue'
import CustomHyperlink from '@/components/CustomHyperlink/CustomHyperlink.vue'
import SecondaryButton from '@/components/SecondaryButton/SecondaryButton.vue'
import ConfirmationModal from '@/components/ConfirmationModal/ConfirmationModal.vue'
import IsActiveComponentV1 from '@/components/IsActiveComponentV1/IsActiveComponentV1.vue'
import PermissionAlert from '@/components/PermissionAlert.vue'
export default {
  components: {
    CustomToggle,
    CustomHyperlink,
    SecondaryButton,
    IsActiveComponentV1,
    ConfirmationModal,
    PermissionAlert,
  },
  data() {
    return {
      loading: false,
      loadingStates: {
        fetchModels: false,
        saveModels: false,
      },
      readPermissionMaster: false,
      writePermissionMaster: false,
      readPermission: false,
      writePermission: false,
      models: [],
      categories: [], // To store categories for dropdown
      search: '',
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 1,
      pageSizeOptions: [10, 20, 50, 100],
      showPageSizeDropdown: false,
      showAddForm: false,
      editMode: false,
      editId: null,
      showErrors: false,
      errors: {
        classification_model_name: '',
        extraction_model_name: '',
        extraction_model_endpoint: '',
      },
      newModel: {
        classification_model_name: '',
        extraction_model_name: '',
        extraction_model_endpoint: '',
        is_active: true,
      },
      pendingStatusChange: null,
      showConfirmModal: false,
    }
  },
  computed: {
    isLoading() {
      return Object.values(this.loadingStates).some((state) => state)
    },
  },
  mounted() {
    document.title = this.$t('models.title')
    this.checkPermissions()
    this.fetchModels()
    document.addEventListener('click', this.handleClickAway)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickAway)
  },
  methods: {
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')

      this.readPermissionMaster = permissions.some((p) => p.object_name === 'MASTER_CONFIGURE_RD' && p.is_active)
      this.writePermissionMaster = permissions.some((p) => p.object_name === 'MASTER_CONFIGURE_WR' && p.is_active)
      this.readPermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_RD' && p.is_active)
      this.writePermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_WR' && p.is_active)
    },
    handleClickAway(event) {
      const dropdownEl = this.$refs.dropdownEl
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.showPageSizeDropdown = false
        this.showEditCategoryDropdown = false
      }
    },
    handleStatusToggle(field, newValue) {
      this.pendingStatusChange = {
        field: { ...field },
        newStatus: newValue,
      }
      this.showConfirmModal = true
    },
    closeConfirmModal() {
      this.showConfirmModal = false
      this.pendingStatusChange = null
    },
    handleStatusChange(value) {
      this.newModel.is_active = value
    },
    async confirmStatusChange() {
      if (!this.pendingStatusChange) return
      const { field, newStatus } = this.pendingStatusChange
      const updatedField = this.models.find((f) => f.id === field.id)
      if (updatedField) {
        updatedField.is_active = newStatus
        await this.updateModalStatus(updatedField)
      }
      this.closeConfirmModal()
      this.pendingStatusChange = null
    },
    async updateModalStatus(selectedModel) {
      if (!selectedModel) return
      this.loadingStates.saveModels = true
      try {
        const payload = {
          extraction_model_name: selectedModel.extraction_model_name,
          classification_model_name: selectedModel.classification_model_name,
          created_by: selectedModel.created_by,
          extraction_model_endpoint: selectedModel.extraction_model_endpoint,
          is_active: Boolean(selectedModel.is_active),
        }
        payload.created_by = selectedModel.created_by // Add created_by only in edit mode
        let response = await put(`/v1/models/${selectedModel.id}`, payload)

        if (response?.data?.code === 200 || response?.data?.code === 201) {
          showToast({
            title: this.$t('models.messages.success_title'),
            message: `${selectedModel.is_active ? this.$t('models.messages.success.status_enabled') : this.$t('models.messages.success.status_disabled')}`,
            type: 'success',
          })
        } else {
          throw new Error(response?.data?.message || this.$t('models.messages.error.update_failed'))
        }
      } catch (err) {
        showToast({
          title: this.$t('models.messages.error_title'),
          message: err.message || this.$t('models.messages.error.update_failed'),
          type: 'error',
        })
      } finally {
        this.loadingStates.saveModels = false
      }
    },

    async fetchModels() {
      this.loadingStates.fetchModels = true
      try {
        let url = `/v1/models?page=${this.page}&pageSize=${this.pageSize}`
        if (this.search) {
          url += `&search=${encodeURIComponent(this.search)}`
        }
        const response = await get(url)
        if (response?.data?.code === 200) {
          this.models = response.data.data.data
          this.total = response.data.data.total
          this.totalPages = Math.ceil(this.total / this.pageSize)
        }
      } catch (err) {
      } finally {
        this.loadingStates.fetchModels = false
      }
    },
    validateForm() {
      let isValid = true
      this.errors = {
        classification_model_name: '',
        extraction_model_name: '',
        extraction_model_endpoint: '',
      }

      if (!this.newModel.classification_model_name?.trim()) {
        this.errors.classification_model_name = this.$t('models.forms.validation.classification_model_name_required')
        isValid = false
      }

      if (!this.newModel.extraction_model_name?.trim()) {
        this.errors.extraction_model_name = this.$t('models.forms.validation.extraction_model_name_required')
        isValid = false
      }

      if (!this.newModel.extraction_model_endpoint?.trim()) {
        this.errors.extraction_model_endpoint = this.$t('models.forms.validation.model_endpoint_required')
        isValid = false
      }

      return isValid
    },
    handleAddModel() {
      this.showAddForm = true
      this.editMode = false
      this.editId = null
      this.resetForm()
    },
    resetForm() {
      this.newModel = {
        classification_model_name: '',
        extraction_model_name: '',
        extraction_model_endpoint: '',
        is_active: true,
      }
      this.showErrors = false
      this.errors = {
        classification_model_name: '',
        extraction_model_name: '',
        extraction_model_endpoint: '',
      }
    },
    cancelAdd() {
      this.showAddForm = false
      this.resetForm()
    },
    async saveDepartment() {
      this.showErrors = true
      if (!this.validateForm()) {
        return
      }
      this.loadingStates.saveModels = true
      try {
        const payload = {
          classification_model_name: this.newModel.classification_model_name,
          extraction_model_name: this.newModel.extraction_model_name,
          extraction_model_endpoint: this.newModel.extraction_model_endpoint,
          is_active: this.newModel.is_active,
        }

        let response
        if (this.editMode) {
          payload.created_by = this.newModel.created_by
          response = await put(`/v1/models/${this.editId}`, payload)
        } else {
          response = await post('/v1/models', payload)
        }

        if (response?.data?.code === 200 || response?.data?.code === 201) {
          showToast({
            title: this.$t('models.messages.success_title'),
            message: `${this.editMode ? this.$t('models.messages.success.updated') : this.$t('models.messages.success.created')}`,
            type: 'success',
          })
          this.showAddForm = false
          this.resetForm()
          await this.fetchModels()
        } else {
          throw new Error(response?.data?.message || 'Operation failed')
        }
      } catch (err) {
        const errorMessage = err.response?.data?.message || err.message
        if (errorMessage.toLowerCase().includes('unique constraint')) {
          showToast({
            title: this.$t('models.messages.error_title'),
            message: this.$t('models.messages.error.duplicate_exists'),
            type: 'error',
          })
        } else {
          showToast({
            title: this.$t('models.messages.error_title'),
            message: errorMessage || this.$t('models.messages.error.create_failed'),
            type: 'error',
          })
        }
      } finally {
        this.loadingStates.saveModels = false
      }
    },
    editModel(model) {
      this.editMode = true
      this.editId = model.id
      this.showAddForm = true
      this.newModel = {
        classification_model_name: model.classification_model_name,
        extraction_model_name: model.extraction_model_name,
        extraction_model_endpoint: model.extraction_model_endpoint,
        is_active: model.is_active,
        created_by: model.created_by,
      }
    },
    togglePageSizeDropdown() {
      this.showPageSizeDropdown = !this.showPageSizeDropdown
    },
    async selectPageSize(size) {
      this.pageSize = size
      this.page = 1
      this.showPageSizeDropdown = false
      await this.fetchModels()
    },
    async goToPreviousPage() {
      if (this.page > 1) {
        this.page--
        await this.fetchModels()
      }
    },
    async goToNextPage() {
      if (this.page < this.totalPages) {
        this.page++
        await this.fetchModels()
      }
    },
    handleFieldChange(fieldName, value) {
      // Clear error for the field
      if (this.errors[fieldName]) {
        this.errors[fieldName] = ''
      }

      // Update the model value
      if (typeof value !== 'undefined') {
        this.newModel[fieldName] = value
      }
    },
  },

  watch: {
    'newModel.classification_model_name'(value) {
      this.handleFieldChange('classification_model_name', value)
    },
    'newModel.extraction_model_name'(value) {
      this.handleFieldChange('extraction_model_name', value)
    },
    'newModel.extraction_model_endpoint'(value) {
      this.handleFieldChange('extraction_model_endpoint', value)
    },
  },
}
</script>

<style scoped>
/* Reuse the same styles as Categories.vue */
.searchBar {
  display: flex;
  align-items: center;
  width: 386px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dadada;
  background: #fff;
  padding: 0 10px;
  gap: 10px;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 25px;
  margin-bottom: 25px;
}
.searchInput {
  border: none;
  outline: none;
  width: 100%;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  color: #8f969b;
}
.button-group {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.cancel-btn {
  padding: 10px 32px;
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  font-family: Archivo;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
}

.save-btn {
  padding: 10px 32px;
  background: var(--primary-color);
  color: white;
  font-family: Archivo;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.form-field label {
  color: #8b8888;
  font-family: Archivo;
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
}

.form-field {
  width: 100%;
}

.form-field input,
.form-field select {
  width: 100%;
  height: 47px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: Archivo;
  font-size: 16px;
  color: #32393e;
}
.newPageTitle {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 28px;
  font-weight: 500;
  line-height: 150%;
}
.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}

.error-border {
  border-color: #dc3545 !important;
}
.createModelBody {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.createModelHeader {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 9px;
}

.createModelHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 9px;
}

.pageDiv {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  background: #fff;
}
.pageSizeDropdownNew {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 4px;
  list-style: none;
  padding: 4px 0;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.pageSizeDropdownNew li {
  padding: 6px 12px;
  cursor: pointer;
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  color: #5c656c;
}

.tooltip-container {
  position: relative;
  width: 100%;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: 100%;
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s;
  word-break: break-all;
  white-space: normal;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.endpoint-cell {
  max-width: 250px;
  padding: 8px;
  position: relative;
}

.endpoint-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default; /* Shows the cursor is hoverable */
}

.endpoint-text:hover {
  color: var(--primary-color); /* Optional: changes text color on hover */
}
</style>
